import { ContractChartGroup, ContractChartGroupStock } from '@/utils/chart-models';

export default {
  props: {
    chartData: {
      type: Array,
      required: true,
      default: null,
    },
    chartDataLoaded: {
      type: Boolean,
      default: false,
    },
    chartOptions: {
      type: Object,
      default: null,
    },
    market: {
      type: Object,
      required: true,
    },
    timeline: {
      type: String,
      required: false,
    },
    chartType: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartType(value) {
      this.createChart(value);
    },
    chartData(value) {
      this.createChart(value);
    },
  },
  methods: {
    createChart(data) {
      if (data && data.length > 0) {
        setTimeout(() => {
          this.renderChart();
        }, ContractChartGroup.renderTimeout());
      } else if (this.$refs.chart) {
        this.$refs.chart.innerHTML = '';
      }
    },
    renderChart() {
      if (!this.$refs.chart) return;
      if (this.chart !== null) {
        this.chart.destroy();
      }
      const ClassName = (this.chartType === 'candle') ? ContractChartGroupStock : ContractChartGroup;
      const group = new ClassName({
        market: this.market,
        timeline: this.timeline,
        data: this.chartData,
        chartOptions: this.chartOptions || {},
      });
      this.chart = group.draw(this.$refs.chart);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-detail-charts/container/container.js